export const pageLoadStarted = (pageTitle, page_referrer, topics, currentStep = null, partnerId, channelId) => {
  // const selectedTags = useSelector((state) => state.AdobeResources.selectedTags);
  let language = localStorage.getItem("lng") === 'en' ? 'en-us' : localStorage.getItem("lng") === 'es' ? 'es-es' : 'en-us';
  // var selectedTopics = topicsName.filter(topic => selectedTags.indexOf(topic.data) !== -1);
  let pageReferrer = page_referrer === null ? '' : page_referrer.includes("null") ? page_referrer.replace("null", "") : page_referrer;
  const dataLayer = window.dataLayer || [];
  let pageLocation = window.location.href;

  if (pageLocation.includes("/onboarding") && currentStep) {
    if (!pageLocation.includes("-step")) {
      pageLocation += ` -step${currentStep}`;
    }
  }
  dataLayer.push({ event_data: null }); // Clear the previous event_data object.
  dataLayer.push({ page_data: null }); // Clear the previous page_data object.
  dataLayer.push({
    event: 'page_load_started',
    detailed_event: 'Page Load Started',
    ...(topics && {  event_data: { "topics": topics }}),
   
    page_data: {
      country: 'US',
      language: language,
      ...(pageReferrer && {  "page_referrer": pageReferrer }),
      page_location: pageLocation,
      page_title: pageTitle,
    },
    user_data: {
      user_login_state: "guest",
      // user_id: "",
      // user_partner_id: partnerId ? partnerId : '',
      // user_channel_id: channelId ? channelId : ''
    },
  });
};

export const pageLoad_Started = (pageTitle, page_referrer, topics, newContentAdded,includeEventFields,event_skill_levelCategory,eventSkillLevelId,eventAdmissionCost,contentCategory) => {
  // const selectedTags = useSelector((state) => state.AdobeResources.selectedTags);
  let language = localStorage.getItem("lng") === 'en' ? 'en-us' : localStorage.getItem("lng") === 'es' ? 'es-es' : 'en-us';
  // var selectedTopics = topicsName.filter(topic => selectedTags.indexOf(topic.data) !== -1);
  let pageReferrer = page_referrer === null ? '' : page_referrer.includes("null") ? page_referrer.replace("null", "") : page_referrer;
  const dataLayer = window.dataLayer || [];

  dataLayer.push({ event_data: null }); // Clear the previous event_data object.
  dataLayer.push({ page_data: null }); // Clear the previous page_data object.
  dataLayer.push({
    event: 'page_load_started',
    detailed_event: 'Page Load Started',
    event_data: {
      profile_status: "",
      topics: topics,
      new_content_added: newContentAdded

    },
    page_data: {
      country: 'US',
      language: language,
      page_referrer: pageReferrer,
      page_location: window.location.href,
      page_title: pageTitle,
       ...(includeEventFields && {
      content_category: contentCategory,
      event_skill_level_category: event_skill_levelCategory,
      event_skill_level: eventSkillLevelId,
      event_admission_cost: eventAdmissionCost
      })

    },
    user: {
      user_login_state: 'guest',
      user_id: ""
    },
  });
};

export const pageLoadCompleted = () => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: 'page_view',
    detailed_event: 'Page Load Completed',
  });
};

export const topicSearch = (topic) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ event_data: null }); // Clear the previous event_data object.
  dataLayer.push({
    event: 'topic_search',
    detailed_event: 'topic_search',
    event_data: {
      topic: topic,
    },
  });
};

export const userRegistrationStep = (stepName, stepNumber, topics, isPartner, partnerId, channelId) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ event_data: null }); // Clear the previous event_data object.
  dataLayer.push({
    event: 'registration_step_view',
    detailed_event: 'User Registration Step Encountered',
    event_data: {
      ...(isPartner && { name: 'partner registration' }),
      step_name: stepName,
      step_number: stepNumber,
      topics: topics,
    },
    user_data: {
      user_type: isPartner ? 'partner' : 'learner',
      user_partner_id: partnerId ? partnerId : '',
      user_channel_id: channelId ? channelId : ''
    }
  });
};
export const userRegistrationClick = (clickLocation, linkText, linkUrl) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ event_data: null }); // Clear the previous event_data object.
  dataLayer.push({
    event: 'user_registration_click',
    detailed_event: 'User Registration Click',
    event_data: {
      click_location: clickLocation,
      link_text: linkText,
      link_url: linkUrl,
    },
  });
};

export const Content_View = (linkText, linkUrl, topics, contentCategory, user_id) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
    "event": "content_view",
    "detailed_event": "Content View",
      "event_data": {
          "link_text": linkText,
          "link_url": linkUrl,
          "topics": topics,
          "content_category": contentCategory
      },
      "user_data": {
          "user_id": ""
      }
  });}
export const contentClick = (linkText, linkUrl, topics, contentCategory) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ event_data: null }); // Clear the previous event_data object.
  dataLayer.push({
    event: 'content_click',
    detailed_event: 'Content Click',
    event_data: {
      ...(linkText && { "link_text": linkText }),
      ...(linkUrl && { "link_url": linkUrl }),
      ...(topics && { "topics": topics }),
      ...(contentCategory && { "content_category": contentCategory })
    },
  });
};
export const userRegistered = (businessZip, topics, hashedEmail, userId, userType, isPartner, partnerData, partnerId, channelId) => {
  const dataLayer = window.dataLayer || [];

  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
    event: "sign_up",
    detailed_event: "User Registered",
    event_data: {
      ...(isPartner && { name: 'partner registration' }),
      ...(isPartner && { access_code: partnerData?.accessCode }),
      business_zip: businessZip,
      topics: topics
    },
    user_data: {
      user_id: userId,
      user_type: userType,
      user_partner_id: partnerId ? partnerId : '',
      user_channel_id: channelId ? channelId : ''
    },
    // partner = trackingData.partner;
    // channel = trackingData.channel;
    hashedEmail: hashedEmail
  });

};
export const userSignedIn = () => {
  const dataLayer = window.dataLayer || [];

  dataLayer.push({
    event: "login",
    detailed_event: "User Signed In",
    user_data: {
      user_login_state: "logged in"
    }
  });
};
// export const userSignedIn = (hashedEmail) => {
//   const dataLayer = window.dataLayer || [];

//   dataLayer.push({
//     event: "login",
//     detailed_event: "User Signed In",
//       user_data: {
//           user_login_state: "logged in",
//           user_id:hashedEmail
//       }
//   });
// };
export const errorMessage = (errorMsg) => {
  const dataLayer = window.dataLayer || [];

  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
    "event": "site_error",
    "detailed_event": "Error Message Presented",
    "event_data": {
      "error_message": errorMsg,
      "type": "System"
    }
  });
}

// Analytics 2388
// audio started

export const audioStarted =(identifier, audioDuration, audioTitle) =>{
  const dataLayer = window.dataLayer || [];
  
  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
    "event": "audio_start",
    "detailed_event": "Audio Started",
      "event_data": {
          "identifier": identifier,
          "audio_duration": audioDuration,
          "audio_title": audioTitle
      }
  });
  }
  
  // Audio reached milestone
  export const audioMileStoneReached =(identifier, audioDuration, audioTitle,milestones) =>{
  const dataLayer = window.dataLayer || [];
  
  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
    "event": "audio_progress",
    "detailed_event": "Audio Milestone Reached",
      "event_data": {
          "identifier": identifier,
          "audio_duration": audioDuration,
          "audio_title": audioTitle,
          "audio_milestones_reached": milestones
      }
  });
  }
  
  // Audio Completed
export const audioCompleted =(identifier, audioDuration, audioTitle) =>{
  
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
    "event": "audio_complete",
    "detailed_event": "Audio Completed",
      "event_data": {
          "identifier": identifier,
          "audio_duration": audioDuration,
          "audio_title": audioTitle
      }
  });
  }


export const videoStarted = (videoDuration, videoTitle, src) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
    "event": "video_start",
    "detailed_event": "Video Started",
    "event_data": {
      "identifier": src,
      "video_duration": videoDuration,
      "video_title": videoTitle
    }
  });
}

export const videoMileStoneReached = (videoDuration, videoTitle, mileStone, src) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
    "event": "video_progress",
    "detailed_event": "Video Milestone Reached",
    "event_data": {
      "identifier": src,
      "video_duration": videoDuration,
      "video_milestones_reached": mileStone,
      "video_title": videoTitle
    }
  });
}
export const videoCompleted = (videoDuration, videoTitle, src) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
    "event": "video_complete",
    "detailed_event": "Video Completed",
    "event_data": {
      "identifier": src,
      "video_duration": videoDuration,
      "video_title": videoTitle
    }
  });
}

export const searchFilter = (filterLocation, languageFilter, topics, skillLevel, statusFilter, typeFilter, datesFilter, filterResults) => {
  const dataLayer = window.dataLayer || [];

  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
      "event": "search_filter",
      "detailed_event": "Search Filter",
      "event_data": {
          "filter_location": filterLocation,
          ...(languageFilter && { "language_filter": languageFilter }),
           ...(topics && { "topics": topics }),
          "skill_level": skillLevel,
           ...(statusFilter && { "status_filter": statusFilter }),
          "type_filter": typeFilter,
           ...(datesFilter && { "dates_filter": datesFilter }),
          "filter_results": filterResults
      }
  });
}
            
export const viewSearchResults = (searchTerm, searchLocation, searchResults, searchType = '') => {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
    "event": "view_search_results",
    "detailed_event": "Site Search",
    "event_data": {
      "search_term": searchTerm,
      "search_location": searchLocation,
      "search_results": searchResults,
       "search_type": searchType || 'Classic',
    }
  });
  dataLayer.push({ event_data: null });
}

export const Click_tracking = (identifier,interaction_name) => {
  const dataLayer = window.dataLayer || [];

  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
    "event": "click",
    "detailed_event": "Ui Interaction",
    "event_data": {
      "identifier": identifier,
      "interaction_name": interaction_name
     }
  });
}

export const CXVideoStarted= (videoDuration, videoTitle, src, videoType) => {
  const dataLayer = window.dataLayer || [];

  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
      "event": "video_start",
      "detailed_event": "Video Started",
      "event_data": {
          "identifier": src,
          "video_duration": videoDuration,
          "video_title": videoTitle,
          "video_type": videoType, // New parameter
      }
  });
}

export const CXVideoCompleted = (videoDuration, videoTitle, src, videoType) => {
  const dataLayer = window.dataLayer || [];

  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
      "event": "video_complete",
      "detailed_event": "Video Completed",
      "event_data": {
          "identifier": src,
          "video_duration": videoDuration,
          "video_title": videoTitle,
          "video_type": videoType, // New parameter
      }
  });
}
export const Register_Event = (title,category,skillLevel,admissionCost,contentCategory) => {
  
  const dataLayer = window.dataLayer || [];


  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
      "event": "register_event",
      "detailed_event": "Register Event",
      "event_data": {
          "calendar_event_title": title,
          "event_skill_level_category":category,
          "event_skill_level_id": skillLevel,
          "event_admission_cost": admissionCost,
          "content_category": contentCategory
      },
      "user_data": {
          "user_id": "",
      }
  },);
}

export const FormStart = (name, formId=[], formType='' ) => {
  const dataLayer = window.dataLayer || [];

  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
      "event": "form_start",
        "detailed_event": "Form Started",
        "event_data": {
            "name": name,
            "form_id": formId[0],
            "form_type": formType,
        },
  },);
}

export const formComplete = (name, fstatus, user_id, formId=[], formType='', vegasId, formTopics, file) => {
  const dataLayer = window.dataLayer || [];

  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
        "event": "form_complete",
        "detailed_event": "Form Submission Succeeded",
        "event_data": {
            "name": name,
            "form_id": formId[0],
            "form_submission_id": vegasId,
            // "profile_status": '',
            "form_type": formType,
            ...(formTopics && { form_topic: formTopics }),
            "file_uploaded": file
        },
        // "user_data": {
        //     "user_id": ''
        // }
  },);
}

export const navLinkClick = (nameIdentifier, text, link) => {
  const dataLayer = window.dataLayer || [];

  dataLayer.push({ event_data: null });  // Clear the previous event_data object.
  dataLayer.push({
    "event": "click",
    "detailed_event": "Navigation Link Clicked",
    "event_data":{ 
      "identifier": nameIdentifier, 
      "link_text": text, 
      "link_url": link, 
    }
  });
  dataLayer.push({ event_data: null });
}